import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faJetFighterUp } from "@fortawesome/free-solid-svg-icons";

const ScrolltoTop = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isHome) return;
    const toggleVisibility = () => setIsVisible(window.scrollY > 1);
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, [isHome]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (isHome) return null;

  return (
    <button
      className={`scroll-to-top-button ${isVisible ? "visible" : ""} `}
      onClick={scrollToTop}
    >
      <FontAwesomeIcon icon={faJetFighterUp} className="i" />
    </button>
  );
};

export default ScrolltoTop;
